import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import SyncData from 'modules/payroll_integrations_a3innuva/components/Incidence/SyncData'
import type { Sync } from 'modules/payroll_integrations_a3innuva/lib/IncidenceSync/store'
import fieldTranslations from 'modules/payroll_integrations_a3innuva/lib/fieldTranslations'

const Available = ({
  sync,
  onSync,
  syncing,
}: {
  sync: Sync
  onSync: () => void
  syncing: boolean
}) => {
  const diffFields = sync.diff_fields
  const diffFieldNames = diffFields ? Object.keys(diffFields) : []

  const translatedDiffFieldNames = diffFieldNames
    .map((fieldName) => fieldTranslations.t(fieldName))
    .join(', ')

  return diffFields ? (
    <>
      <Text.Header2>
        {i18n.t('payroll_integrations.incidences.a3innuva.nationality.available.title')}
      </Text.Header2>
      <Box>
        {i18n.tp('payroll_integrations.incidences.a3innuva.nationality.available.message', {
          fieldNames: translatedDiffFieldNames,
          count: diffFieldNames.length,
        })}
      </Box>
      <SyncData fields={diffFields} onSync={onSync} syncing={syncing} />
    </>
  ) : null
}

export default Available
